import macbook from "./macbook";
import macbookPro2016 from "./macbook-pro-2016";
import macbookAir from "./macbook-air";
import surfaceBook from "./surface-book";

export default {
	id: "laptops",
	title: "Laptops",
	width: "13em",
	height: "7em",
	items: [macbook, macbookPro2016, macbookAir, surfaceBook]
};
